import { MenuAccessDetail } from './menu-access-detail.model';


export class MenuDetails implements IMenuDetails {
    menuId!: number;
    sequenceId!: number;
    menuName!: string | undefined;
    parentId!: number;
    menuAccessDetail!: MenuAccessDetail;

    constructor(data?: IMenuDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.menuId = _data["menuId"];
            this.sequenceId = _data["sequenceId"];
            this.menuName = _data["menuName"];
            this.parentId = _data["parentId"];
            this.menuAccessDetail = _data["menuAccessDetail"] ? MenuAccessDetail.fromJS(_data["menuAccessDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MenuDetails {
        data = typeof data === 'object' ? data : {};
        let result = new MenuDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menuId"] = this.menuId;
        data["sequenceId"] = this.sequenceId;
        data["menuName"] = this.menuName;
        data["parentId"] = this.parentId;
        data["menuAccessDetail"] = this.menuAccessDetail ? this.menuAccessDetail.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IMenuDetails {
    menuId: number;
    sequenceId: number;
    menuName: string | undefined;
    parentId: number;
    menuAccessDetail: MenuAccessDetail;
}

